import React from "react";
import {
  FaBriefcase,
  FaMapMarkerAlt,
  FaClock,
  FaHeart,
  FaUsers,
  FaChartLine,
  FaLeaf,
  FaGraduationCap,
} from "react-icons/fa";

const CareerPage = () => {
  const jobs = [
    {
      title: "Program Manager",
      type: "Full-time",
      location: "Chandauli, UP",
      description:
        "Lead our grassroots programs, manage teams, and drive impact in rural communities.",
      icon: <FaBriefcase />,
    },
    {
      title: "Field Coordinator",
      type: "Full-time",
      location: "Multiple locations",
      description:
        "Coordinate on-ground activities, liaise with communities, and report program outcomes.",
      icon: <FaUsers />,
    },
    {
      title: "Communications Officer",
      type: "Full-time",
      location: "Remote / Chandauli",
      description:
        "Handle social media, content creation, and donor communications.",
      icon: <FaChartLine />,
    },
    {
      title: "Fundraising Associate",
      type: "Full-time",
      location: "Chandauli, UP",
      description:
        "Develop fundraising strategies, manage donor relationships, and write grant proposals.",
      icon: <FaHeart />,
    },
  ];

  const benefits = [
    { icon: <FaLeaf />, text: "Meaningful work with community impact" },
    { icon: <FaGraduationCap />, text: "Learning & development opportunities" },
    { icon: <FaUsers />, text: "Collaborative & inclusive culture" },
    { icon: <FaClock />, text: "Flexible work arrangements" },
  ];

  return (
    <div className="relative bg-gradient-to-br from-[#eafaff] via-white to-[#dff7fb] min-h-screen overflow-hidden">
      <div className="absolute top-20 left-10 w-72 h-72 bg-[#1298b5]/20 rounded-full mix-blend-multiply filter blur-3xl animate-blob"></div>
      <div className="absolute bottom-20 right-10 w-72 h-72 bg-[#f97316]/20 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-2000"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="text-center mb-10 animate-fadeInDown">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#1298b5] to-[#0b819b] rounded-2xl text-white mb-4 shadow-lg">
            <FaBriefcase className="text-2xl" />
          </div>

          <h1 className="text-4xl md:text-5xl font-extrabold text-[#073b4c] mb-3">
            Careers at <span className="text-[#1298b5]">Aabharan</span>
          </h1>

          <div className="w-20 h-1 bg-gradient-to-r from-[#1298b5] to-[#f97316] mx-auto rounded-full mb-4"></div>

          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            Join our team and make a lasting impact. We're looking for
            passionate individuals to grow with us.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-12 animate-fadeInUp">
          {jobs.map((job, idx) => (
            <div
              key={idx}
              className="group bg-white/90 backdrop-blur-sm rounded-2xl shadow-lg p-5 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 border border-[#d8f4f8] hover:border-[#1298b5]/50"
            >
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 bg-[#eafaff] rounded-xl flex items-center justify-center text-[#1298b5] text-lg flex-shrink-0 group-hover:bg-[#1298b5] group-hover:text-white transition-all duration-300">
                  {job.icon}
                </div>

                <div className="flex-1">
                  <h3 className="text-lg font-bold text-[#073b4c] mb-1">
                    {job.title}
                  </h3>

                  <div className="flex flex-wrap gap-3 text-xs text-gray-500 mb-3">
                    <span className="flex items-center gap-1">
                      <FaClock className="text-[#1298b5] text-xs" /> {job.type}
                    </span>

                    <span className="flex items-center gap-1">
                      <FaMapMarkerAlt className="text-[#f97316] text-xs" />{" "}
                      {job.location}
                    </span>
                  </div>

                  <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                    {job.description}
                  </p>

                  <button className="bg-gradient-to-r from-[#1298b5] to-[#0b819b] hover:from-[#f97316] hover:to-[#fb923c] text-white px-4 py-2 rounded-lg text-xs font-semibold transition-all duration-300 shadow hover:shadow-md">
                    Apply Now
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-white/95 rounded-3xl shadow-xl p-6 md:p-8 max-w-4xl mx-auto border border-[#d8f4f8] animate-fadeInUp animation-delay-300">
          <h2 className="text-2xl font-extrabold text-[#073b4c] mb-6 text-center">
            Why Join <span className="text-[#1298b5]">Aabharan?</span>
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {benefits.map((benefit, idx) => (
              <div
                key={idx}
                className="flex items-center gap-3 p-4 bg-[#eafaff] rounded-xl border border-[#d8f4f8] hover:bg-white hover:shadow-md transition"
              >
                <div className="w-9 h-9 bg-[#1298b5] rounded-lg flex items-center justify-center text-white text-sm">
                  {benefit.icon}
                </div>

                <p className="text-[#073b4c] text-sm font-semibold">
                  {benefit.text}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 text-center text-gray-600 text-sm">
          <p>
            Don't see a role that fits? Send us your resume at{" "}
            <span className="font-semibold text-[#1298b5]">
              directors@aabharan.org
            </span>
          </p>

          <p className="mt-2">
            📍 NAIBAZAR, DURGA PUJA RD, CHANDAULI, UP - 232108
          </p>
        </div>
      </div>

      <style>{`
        @keyframes blob {
          0% { transform: translate(0px, 0px) scale(1); }
          33% { transform: translate(30px, -50px) scale(1.08); }
          66% { transform: translate(-20px, 20px) scale(0.95); }
          100% { transform: translate(0px, 0px) scale(1); }
        }

        .animate-blob {
          animation: blob 7s infinite;
        }

        .animation-delay-2000 {
          animation-delay: 2s;
        }

        .animation-delay-300 {
          animation-delay: 0.3s;
        }

        @keyframes fadeInDown {
          from { opacity: 0; transform: translateY(-20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .animate-fadeInDown {
          animation: fadeInDown 0.8s ease-out forwards;
        }

        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .animate-fadeInUp {
          animation: fadeInUp 0.8s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default CareerPage;